import { render, staticRenderFns } from "./DlSource.vue?vue&type=template&id=0c04172c&scoped=true&"
import script from "./DlSource.vue?vue&type=script&lang=js&"
export * from "./DlSource.vue?vue&type=script&lang=js&"
import style0 from "./DlSource.vue?vue&type=style&index=0&id=0c04172c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c04172c",
  null
  
)

export default component.exports